import React from 'react';
import PropTypes from 'prop-types';
import qs from 'qs';

const defaultOptions = {
  autoplay: 1,
  controls: 1,
  rel: 0,
};

export default function YoutubeEmbed(props) {
  const { title, videoId, ...embedOptions } = props;

  const videoPlayerParams = qs.stringify(
    { ...defaultOptions, ...embedOptions },
    { addQueryPrefix: true },
  );

  return (
    <iframe
      src={`https://www.youtube.com/embed/${videoId}${videoPlayerParams}`}
      title={title}
      allowFullScreen
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      frameBorder="0"
    />
  );
}

YoutubeEmbed.propTypes = {
  videoId: PropTypes.string.isRequired,
  title: PropTypes.string,
};
